import React from "react";
import { connect } from "react-redux";
import AddIcon from "../UIComponents/AddIcon";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { getRankList } from "../Actions/RankManagementAPI";
import RankCard from "./RankCard";
import Role from "../helpers/role";

const searchData = {
    Name: "",
    PageNumber: 1,
    PageSize: 25,
};
let userRole = localStorage.getItem("UserRoles");
let currentuser = JSON.parse(localStorage.getItem("currentUser"));

class RankManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchData: {
                Name: "",
                PageNumber: 1,
                PageSize: 25,
            },
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.SearchData = this.SearchData.bind(this);
        this.ClearInput = this.ClearInput.bind(this);
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch({ type: "SubBannerTitle", data: "Rank Management" });
        this.props.dispatch(getRankList(this.state.searchData));
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.searchData[nodeName] = e.target.value;
        this.setState({});
    }

    SearchData(Pgno) {
        const { dispatch } = this.props;
        this.state.searchData.PageNumber = Pgno;
        dispatch(getRankList(this.state.searchData));
    }

    eyeclick(item) {
        const { history, dispatch } = this.props;
        dispatch({ type: "RankDetail", data: item });
        history.push(`/Home/Management/EditRank/${item.rankId}`);
    }

    DeleteRank(item) {
        const { dispatch } = this.props;
        confirmAlert({
            message: "Are you sure want to delete?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        let Rank = {
                            rankId: item.rankId,
                            rankName: item.rankName,
                            isDeleted: true,
                            modifiedBy: currentuser.name
                        };
                        let url = `${API.PostRank}`;
                        axios.put(url, Rank)
                            .then((response) => {
                                dispatch(getRankList(searchData));
                                dispatch({
                                    type: "DeleteRankSuccess",
                                    data: response.data
                                })
                                toast.success('Deleted Successfully', {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });

                            })
                            .catch((error) => {
                                dispatch({
                                    type: "DeleteRankFailure",
                                    error: "ERROR"
                                })
                            })
                    },
                },
                {
                    label: "No",
                    onClick: () => { },
                },
            ],
            overlayClassName: 'custom-alert'
        });
    }


    ClearInput() {
        this.state.searchData.Name = "";
        this.props.dispatch(getRankList(this.state.searchData));
        this.setState({});
    }

    BacktoPrevious() {
        this.props.history.goBack();
    }

    render() {
        const { showSidePane, RankList } = this.props;
        return (
            <div className="full-height">
                <div className="pt-3">
                    <div className="row px-3 pb-3">
                        <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            onClick={() => this.BacktoPrevious()}
                        >
                            <div style={{ position: 'relative' }}>
                                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
                            </div>
                        </button>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="panel-box">
                                <div
                                    className=" card MM-card-header mb-0"
                                    style={{ backgroundColor: "white" }}
                                >
                                    <div
                                        className="card-body flex"
                                        style={{
                                            padding: "0rem",
                                            backgroundColor: "#1a3464",
                                            color: "white",
                                        }}
                                    >
                                        <h5
                                            className="card-title ml-2 mt-2"
                                            style={{ color: "092a51" }}
                                        >
                                            Rank Management
                                        </h5>
                                        {userRole == Role.mmpl ? (<></>) : (<>
                                            <div
                                                className="m-1 flex"
                                                onClick={() => this.AddRank()}
                                            >
                                                <span className="card-title m-auto">Add Rank</span>
                                                <AddIcon />
                                            </div>
                                        </>)}
                                    </div>
                                </div>
                                <div className="search-filter-box">
                                    <div className="row pb-3">
                                        <div
                                            className="col-lg-4 "
                                        >
                                            <label className="form-label">Name</label>
                                            <br></br>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="Name"
                                                placeholder="Name"
                                                value={this.state.searchData.Name}
                                                onChange={(e) => this.handleInputChange(e)}
                                            ></input>
                                        </div>
                                        <div className="col-lg-8">
                                            <label className="mt-4"></label>
                                            <br></br>
                                            <div
                                                className="search-btn-col"
                                                style={{ textAlign: "end" }}
                                            >
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit"
                                                    onClick={() => this.SearchData(1)}
                                                >
                                                    {" "}
                                                    Search{" "}
                                                </button>

                                                <button
                                                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                    type="button"
                                                    onClick={() => this.ClearInput()}
                                                >
                                                    {" "}
                                                    Clear{" "}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {RankList ? (
                        <RankCard
                            arraylist={RankList.data}
                            pageSize={RankList.pagination ? RankList.pagination.pageSize : 0}
                            totalRecords={
                                RankList.pagination
                                    ? RankList.pagination.totalcount
                                    : 0
                            }
                            DeleteRank={(item) => this.DeleteRank(item)}
                            eyeclick={(item) => this.eyeclick(item)}
                            setUpdatedState={(value) => this.SearchData(value)}
                        />
                    ) : null}
                </div>
            </div>

        );
    }

    AddRank = () => {
        this.props.history.push(`/Home/Management/AddRank`);
    };
}

function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
        RankList: state.RankManagementReducer.RankList || [],
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(RankManagement);